module.exports = __webpack_public_path__ + "static/media/home-hero-phones.e7f5b064.png";